'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeToReducer = require('type-to-reducer');

var _typeToReducer2 = _interopRequireDefault(_typeToReducer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TITLE = 'Keep in mind...';
var DESCRIPTION = 'Financial Services has openings for all\ntypes of people, but based on your skills and interests, you\nshould keep in mind that:';
var INTERESTS = 'The financial services industry requires ';
var SKILLS = 'Success requires ';

var initialState = {
  title: TITLE,
  description: DESCRIPTION,
  interests: INTERESTS,
  skills: SKILLS
};

exports.default = (0, _typeToReducer2.default)({}, initialState);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/components/KeepInMind/reducer.js
// module id = 1080
// module chunks = 0